(function() {
    'use strict';

    angular
        .module('mVtasWebApp')
        .controller('ModelosdeimpresoraDetailController', ModelosdeimpresoraDetailController);

    ModelosdeimpresoraDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'Modelosdeimpresora', 'Pv'];

    function ModelosdeimpresoraDetailController($scope, $rootScope, $stateParams, previousState, entity, Modelosdeimpresora, Pv) {
        var vm = this;

        vm.modelosdeimpresora = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('mVtasWebApp:modelosdeimpresoraUpdate', function(event, result) {
            vm.modelosdeimpresora = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
